module.exports = __webpack_public_path__ + "img/christiane-sohn-avatar.ce50dcd2.jpg";